export default function Logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('adminType');
  window.location.assign('/login');
  return null;
}
